<template>
  <div class="k-no-data"><slot>暂无数据</slot></div>
</template>

<style>
.k-no-data {
  font-size: .3rem;
  line-height: 1.5;
  padding: 2.5em 0;
  text-align: center;
  color: #939393;
}
</style>

<script>
  export default {
    name: 'k-no-data',
    props: {

    }
  }

</script>
